import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import { type CompanyDefaultsAccessResponse } from "../types/company-defaults-access.types.ts"

const PATH = "/user/company-defaults/access/"

export const getCompanyDefaultsAccess = (
  teamId?: string | null
): Promise<ApiResponse<CompanyDefaultsAccessResponse>> =>
  request.api.get(PATH, teamId ? { team: teamId } : undefined)
